import * as net from 'util/Net';

export interface AuditDownloadTableAsCSVParams {
  tableName: string;
  structuredTableProvenanceUuid?: string;
  documentLikeId?: string;
  parentAuditIds: Array<string>;
}

export function auditDownloadTableAsCSV(params: AuditDownloadTableAsCSVParams): Promise<void> {
  return net.postJSONPromise({
    url: '/1/api/download-csv:log-audit',
    data: params,
  });
}
